export function formatBalanceWithCommas(number) {
    if (typeof number !== 'number') {
        return String(number); // Возвращаем как строку, если это не число
    }


    return number.toLocaleString('en-US', {
        maximumFractionDigits: 4
    });
}